import Swiper, { Navigation, Pagination, Autoplay, EffectFade } from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';
import '../css/tailwind/config.css';

document.addEventListener('DOMContentLoaded', () => {
  const swiper = new Swiper('.travel-mv-swiper', {
    modules: [Navigation, Pagination, Autoplay, EffectFade],
    loop: true,
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
    autoplay: {
      delay: 5000,
    },
    followFinger: false,
    speed: 3000,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });

  const mvPauseIcon = document.getElementById('travel-mv-swiper-icon-pause');
  const mvPlayIcon = document.getElementById('travel-mv-swiper-icon-play');
  if (mvPauseIcon) {
    mvPauseIcon.addEventListener('click', () => {
      swiper.autoplay.stop();
    });
  }
  if (mvPlayIcon) {
    mvPlayIcon.addEventListener('click', () => {
      swiper.autoplay.start();
    });
  }

  const swiperContent = new Swiper('.travel-content-swiper', {
    modules: [Autoplay, EffectFade],
    loop: true,
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
    autoplay: {
      delay: 5000,
    },
    followFinger: false,
    speed: 3000,
  });

  // ボタンのクリックで停止/再生を切り替え
  const slidepauseIcon = document.getElementById(
    'travel-content-swiper-icon-pause'
  );
  const slideplayIcon = document.getElementById(
    'travel-content-swiper-icon-play'
  );
  if (slidepauseIcon) {
    slidepauseIcon.addEventListener('click', () => {
      swiperContent.autoplay.stop();
    });
  }
  if (slideplayIcon) {
    slideplayIcon.addEventListener('click', () => {
      swiperContent.autoplay.start();
    });
  }

  const gastronomic = new Swiper('.gastronomic-swiper', {
    modules: [Navigation],
    loop: false,
    speed: 3000,
    centeredSlides: false,
    slidesPerView: 1.5,
    spaceBetween: 24,
    navigation: {
      nextEl: '.gastronomic-swiper-button-next',
      prevEl: '.gastronomic-swiper-button-prev',
      disabledClass: 'gastronomic-swiper-disabled',
    },
    breakpoints: {
      // 640px以上のとき
      768: {
        slidesPerView: 2.7,
        spaceBetween: 24,
      },
    },
  });

  const traditional = new Swiper('.traditional-swiper', {
    modules: [Navigation],
    loop: false,
    speed: 3000,
    centeredSlides: false,
    slidesPerView: 1.5,
    spaceBetween: 24,
    navigation: {
      nextEl: '.traditional-swiper-button-next',
      prevEl: '.traditional-swiper-button-prev',
      disabledClass: 'traditional-swiper-disabled',
    },
    breakpoints: {
      // 640px以上のとき
      768: {
        slidesPerView: 2.7,
        spaceBetween: 24,
      },
    },
  });

  window.addEventListener('scroll', function () {
    // スクロール量を取得
    const scroll = window.scrollY;
    // 画面の高さを取得
    const windowHeight = window.innerHeight;
    // すべての.boxを取得
    const boxes = document.querySelectorAll('.fadeEffectBox');

    boxes.forEach(function (box) {
      // boxまでの高さを取得
      const distanceToBox = (box as HTMLElement).offsetTop;
      // 下記条件が成り立つときだけboxにis-activeクラスを付与する
      if (scroll + windowHeight > distanceToBox) {
        box.classList.add('is-active');
      }
    });
  });
});
